<template>
  <footer class="border-t border-white/5 bg-black py-10 mt-auto">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col sm:flex-row justify-between items-center gap-6">

        <!-- Brand -->
        <div class="text-center sm:text-left">
          <p class="text-base font-bold">
            <span class="text-white">MT</span><span class="text-cyan-400">TECHDEV</span>
          </p>
          <p class="text-xs text-gray-600 mt-1 font-mono">Desarrollando con propósito</p>
        </div>

        <!-- Social links -->
        <div class="flex items-center gap-5">
          <a
            href="https://linkedin.com/in/harry-bernol-sandoval-gomel"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-2 text-gray-500 hover:text-white transition-colors duration-200 text-sm"
            aria-label="LinkedIn"
          >
            <img src="/icons/linkedin-icon.svg" alt="" class="w-5 h-5" />
            <span class="hidden sm:inline">LinkedIn</span>
          </a>
          <a
            href="https://github.com/Harrybsg"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-2 text-gray-500 hover:text-white transition-colors duration-200 text-sm"
            aria-label="GitHub"
          >
            <img src="/icons/github-icon.svg" alt="" class="w-5 h-5" />
            <span class="hidden sm:inline">GitHub</span>
          </a>
          <a
            href="https://x.com/HarryBernol"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-2 text-gray-500 hover:text-white transition-colors duration-200 text-sm"
            aria-label="X (Twitter)"
          >
            <img src="/icons/x-icon.svg" alt="" class="w-5 h-5" />
            <span class="hidden sm:inline">X</span>
          </a>
          <a
            href="mailto:harrybsg@gmail.com"
            class="flex items-center gap-2 text-gray-500 hover:text-cyan-400 transition-colors duration-200 text-sm"
            aria-label="Email"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
            <span class="hidden sm:inline">Email</span>
          </a>
        </div>
      </div>

      <div class="mt-8 pt-6 border-t border-white/5 text-center text-xs text-gray-700 font-mono">
        © {{ currentYear }} Harry Bernol Sandoval. Todos los derechos reservados.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSide',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
